/*
 * Wrapper items for aodItem data
 *
 *  ? Make storage aware?
 *
 * todo - item /callName renaming from MCC -> webpack
 */
import Role from "../Role";
import {filter, includes, isNumber, isObject, isString,
    keys, map, merge, omit, pick, uniq} from "lodash";
import {capitalizeFirstLetter, unCapitalizeFirstLetter} from "../aodUtils";

//const Person = require('./object/person');

// todo
//  dettach from window - invoke as needed
//  underscror -> lodash   ?contains ? what else
//  switch use of aod -> objectFactory

//  todo
//   ? separate out data transformation from Object instance
//   ? Make JSON to object + data parse part of callName


// Objects are created from the JSON plain data structures
// adds CRUD,  owners/creators,  Sharing & Roles
// todo history - see projects
// Plus any special functionality for the Object e.g Projects dealing with ProjectItems...


    // This doesn't work in wbepacked environment
    function getKind(obj){
        if(typeof(obj)==="undefined")return "undefined";
        if(obj===null)return "Null";
        var res = Object.prototype.toString.call(obj).match(/^\[object\s(.*)\]$/)[1];
        if(res==="Object"){
            res = obj.constructor.name;
            if(typeof(res) !== 'string' || res.length === 0){
                //if(obj instanceof jQuery)return "jQuery";// jQuery build stranges Objects
                if(obj instanceof Array)return "Array";// Array prototype is very sneaky
                return "Object";
            }
        }
        return res;
    }

    // todo ? add clone method - would allow for overridding



    export default function AodObject(record, aodService, objType)
    {
        // Todo ? dicey - take precautions
        //  - just extract properties
        //  - do it 1st so AOdObject properties "protected" properties won't get overwritten
        merge(this,pick(record, keys(record)));

        this.aodService = aodService;

        this.objType = objType || getKind(this);
        //this.item = item;  // itemName really
        this.callName = unCapitalizeFirstLetter(this.objType);

        this.itemCall = aodService.itemCalls[this.callName];
        this.managedFileCall = aodService.itemCalls['managedFile'];

        if (isString(record)) {
            record = JSON.parse(record);
        }

        //TBD deep scan for dates
        //convertDates(this);
        //done in aodItem now

        // Ids to be ignored when working with shares
        this.excludeIds = [];

        if (this.createdBy) {
            //this.createdBy = new Person(this.createdBy);
            this.createdBy = aodService.factory.get('Person',this.createdBy);
            this.createdById = this.createdBy.id;
        }
        if (this.createdById) {
            this.excludeIds.push(this.createdById);
        }
        if (this.ownedBy) {
            //this.ownedBy = new Person(this.ownedBy);
            this.ownedBy = aodService.factory.get('Person',this.ownedBy);
            this.ownedById = this.ownedBy.id;
        }
        if (this.ownedById) {
            this.excludeIds.push(this.ownedById);
        }
        else if (this.createdById) {
            this.ownedById = this.createdById ;
        }

        // Don' ALWAYS wnat to exclude self
        //if (aod.loginId) {
        //    this.excludeIds.push(aod.loginId);
        //}


        //TBD - Not good using this for share summary - does show self for other peoples projs
        this.excludeIds = uniq(this.excludeIds);

        //this.buildShares();
    }

    // ?AodObject.login


    AodObject.prototype = {
        objType: 'unknown',
        //item: 'unknown',  // aodItem
        callName: 'unknown',  // aodItem
        shareTypes: ['ACCESS', 'COMMENT', 'CONTRIBUTE', 'EDIT'],

        // Used to allow objects to get related objects of a variable type
        //  e.g. Person owner can  be Advertiser or Production Unit etc
        getAodItem: function(item,itemIdProp)
        {
            itemIdProp = itemIdProp || item+'Id';
            var objectName = capitalizeFirstLetter(item);

            if (this.aodService.factory.hasObject(objectName) )
            {
                ///e.g. 'owner'

                if (item in this && isObject(this[item]))
                {
                    //if (!(this[item] instanceof aod[objectName]))
                    // this[item] = new aod[objectName]( this[item] );
                    this[item] = this.aodService.factory.get(objectName, this[item] );
                }
                else if (itemIdProp in this && isNumber(this[itemIdProp]))
                {
                    // todo not what (if anything) this was doing
                    //this[item] = new aod[objectName]( this[itemIdProp] );
                    //this[item] = this.aodService.factory.get[objectName]( this[itemIdProp] );
                    // thinking this should be
                    this[item] = this.aodService.factory.get(objectName, {id: this[itemIdProp] });
                }
            }

            return this[item];
        },

        save: function save(original)
        {
            var self = this;
            var data = this.getSaveData();

            // this object represents the new/updated state
            // however shares are submitted as a differences,
            // so we need to compare with the original
            if (original)  //TBD test object
            {
                //Create list of created / deleted roles (update == delete + create,  e.g. comment->edit)
                data.changedRoles = Role.getDiff(this.getShares(), original.getShares()) ;
            }

            return this.itemCall.update(this.id, data)
                .then(function(response)
                {
                    if (original)
                    {
                        //var returnedItem = new self.constructor(response[self.item]);
                        //?? const returnedItem = new self.constructor(response[self.item], self.aodService);
                        const returnedItem = self.aodService.factory.get(self.objType, response[self.callName]);

                        data.changedRoles = Role.getDiff(self.getShares(), returnedItem.getShares());
                        // One retry - in case current roles were out of date
                        if (data.changedRoles.length > 0) {
                            return self.itemCall.update(self.id, data);
                        }
                    }
                    return response;
                }).then(function(response)
                {
                    //var returnedItem = new self.constructor(response[self.item]);
                    const returnedItem = self.aodService.factory.get(self.objType, response[self.callName]);
                    if (original && Role.getDiff(original.getShares(), returnedItem.getShares()).length > 0) {
                        //TODO ? local version number
                        returnedItem.recordVersion = Math.max(original.recordVersion + .0001, returnedItem.recordVersion) ;  // just enough to trigger model
                    }
                    return returnedItem;
                });
        },

        getSaveData: function()
        {
            //TBD support overide set of keys
            //TBD nested data

            //var data = pick(_.clone(this),this.getSaveFields);
            var data = pick(this,this.getSaveFields());
            //revertDates(data);
            data.recordVersion = Math.floor10(data.recordVersion); // Remove microversions

            // remove 'transients' & non-editable & references
            return omit(data, ['objType', 'item', 'itemView', 'nextIndex', 'createdDate', 'updatedDate',
                'metroReference', 'storeFileVersion', 'timestamp', 'targetedRoles', 'excludeIds', 'trash',
                'aodService', 'itemCall', 'callName', 'managedFileCall'
            ]);
        },

        getSaveFields: function(){
            return keys(this);
        },

        create: function(parent)  //TBD support multiple connections
        {
            if (isObject(parent)) {
                // todo objects fromm MCC wil have item....
                const parentItem = parent.callName || parent.item;
                this[parentItem + 'Id'] =  parent.id;
            }
            var self= this;

            return this.itemCall.create(this.getCreateData())
                .then(function(response)
                {
                    //return new self.constructor(response[self.item]);
                    return self.aodService.factory.get(self.objType, response[self.callName]);
                });
        },

        getCreateData: function()
        {
            var data = this.getSaveData();
            data.changedRoles = Role.getDiff(this.getShares());
            return omit(data, [
                'id', 'recordVersion', 'timestamp',
                'aodService', 'itemCall', 'callName', 'managedFileCall'
            ]);
        },

        remove: function()  //used to be delete
        {
            return this.itemCall.remove(this.id);
        },

        addComment: function(comment)
        {
            var data = pick(this,['id','recordVersion']);
            data.newComment = comment;
            var self = this;

            return this.itemCall.update(this.id, data)
                .then(function(response)
                {
                    //return new self.constructor(response[self.item]);
                    return self.aodService.factory.get(self.objType, response[self.callName]);
                });
        },

        merge: function(record)
        {
            return merge(true, this, record);
            // replace ? return record;
        },

        addShareExclude: function(id)
        {
            this.excludeIds.push(id);
        },
        can: function(task)
        {
            return isObject(this.canPerform) && includes(this.canPerform,task) ;
        },
        getShareRoles: function()
        {
            return map(this.shareTypes, function(type)
            {
                return (type +'_'+ this.callName).toUpperCase();
            },this);
        },
        getShares: function()
        {
            if (! (this.targetedRoles && this.targetedRoles.length) )
                return [];

            var shareRoles = this.getShareRoles();

            return filter(this.targetedRoles, function(role)
            {
                if (includes(this.excludeIds, role.sourceId))
                    return false;

                return includes(shareRoles, role.userPrivilege);
            },this);
        },

        uploadFile: function(file, options){
            //todo default class & type by objType
            return this.managedFileCall.uploadAndAttach(file, this.id, this.objType, options);
        },

        retrieveFile: function(file, options={}){
            //todo default class & type by objType
            const fileInfo = pick(file, 'url', 'type', 'name');
            if (options.isAsset){
                fileInfo.name = this.metroReference;
            }
            return this.managedFileCall.retrieveAndAttach(fileInfo, this.id, this.objType, options);
        }
    };

    // TBD add more than one - defineProperties
    /* - Not Used in MCC & defineProperty not suppported in older browsers
    Object.defineProperty(AodObject.prototype, "isMine", {
        get: function()
        {
            return this.ownedById === AodObject.loginId ;
        },
        enumerable: true
    });
    */

    AodObject.loginId = null;


// Only Project & Project Item & Person all have overriding / extra code
// Other uncustomised objects are in AodObjectFactory.js

